import { render, staticRenderFns } from "./PrescriberOrders.vue?vue&type=template&id=0ed0946a"
import script from "./PrescriberOrders.vue?vue&type=script&lang=js"
export * from "./PrescriberOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports